/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as LudoIndexImport } from './routes/ludo/index'
import { Route as BackgammonIndexImport } from './routes/backgammon/index'
import { Route as LudoTokenMatchIDImport } from './routes/ludo/$token/$matchID'
import { Route as BackgammonTokenMatchIDImport } from './routes/backgammon/$token/$matchID'

// Create/Update Routes

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LudoIndexRoute = LudoIndexImport.update({
  path: '/ludo/',
  getParentRoute: () => rootRoute,
} as any)

const BackgammonIndexRoute = BackgammonIndexImport.update({
  path: '/backgammon/',
  getParentRoute: () => rootRoute,
} as any)

const LudoTokenMatchIDRoute = LudoTokenMatchIDImport.update({
  path: '/ludo/$token/$matchID',
  getParentRoute: () => rootRoute,
} as any)

const BackgammonTokenMatchIDRoute = BackgammonTokenMatchIDImport.update({
  path: '/backgammon/$token/$matchID',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/backgammon/': {
      id: '/backgammon/'
      path: '/backgammon'
      fullPath: '/backgammon'
      preLoaderRoute: typeof BackgammonIndexImport
      parentRoute: typeof rootRoute
    }
    '/ludo/': {
      id: '/ludo/'
      path: '/ludo'
      fullPath: '/ludo'
      preLoaderRoute: typeof LudoIndexImport
      parentRoute: typeof rootRoute
    }
    '/backgammon/$token/$matchID': {
      id: '/backgammon/$token/$matchID'
      path: '/backgammon/$token/$matchID'
      fullPath: '/backgammon/$token/$matchID'
      preLoaderRoute: typeof BackgammonTokenMatchIDImport
      parentRoute: typeof rootRoute
    }
    '/ludo/$token/$matchID': {
      id: '/ludo/$token/$matchID'
      path: '/ludo/$token/$matchID'
      fullPath: '/ludo/$token/$matchID'
      preLoaderRoute: typeof LudoTokenMatchIDImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  BackgammonIndexRoute,
  LudoIndexRoute,
  BackgammonTokenMatchIDRoute,
  LudoTokenMatchIDRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/backgammon/",
        "/ludo/",
        "/backgammon/$token/$matchID",
        "/ludo/$token/$matchID"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/backgammon/": {
      "filePath": "backgammon/index.tsx"
    },
    "/ludo/": {
      "filePath": "ludo/index.tsx"
    },
    "/backgammon/$token/$matchID": {
      "filePath": "backgammon/$token/$matchID.tsx"
    },
    "/ludo/$token/$matchID": {
      "filePath": "ludo/$token/$matchID.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
